function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
* @class ReportFilters.
*
*/
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import entityComposition from '../common/classes/entityComposition';
import ControlFilterSwitch from '../common/controls/controlFilterSwitch';
import { getIsPermittedWithAnyOfThesePermissions } from '../common/classes/permissions';
import JobAndPhaseCodeFilter from './jobAndPhaseCodeFilter';
import PieceFilter from './pieceFilter';
import ReportFormFilter from './reportFormFilter';
import searchFactory from '../common/lookups/searchFactory';
import ShowDeletedFilter from '../common/filters/showDeletedFilter';
import tieredFilterEntity from '../common/lookups/tieredFilterEntity';
import displaySettings from '../../utils/displaySettings';
import WeekEndingFilter from './weekEndingFilter';
const PieceSearch = searchFactory('jobPiece');
const ReportAssetFilter = tieredFilterEntity('report', 'assetFilterReport', 'asset');
const ReportAssetSearch = searchFactory('assetFilterReport');
const ReportCreatorFilter = tieredFilterEntity('report', 'creatorFilterReport', 'user');
const ReportCreatorSearch = searchFactory('creatorFilterReport');
const ReportCurrentStateFilter = tieredFilterEntity('report', 'currentStateFilterReport', 'currentState');
const ReportCurrentStateSearch = searchFactory('currentStateFilterReport');
const ReportOrganizationFilter = tieredFilterEntity('report', 'orgFilterReport', 'organization');
const ReportOrganizationSearch = searchFactory('orgFilterReport');
const ReportSeverityFilter = tieredFilterEntity('report', 'issueSeverityFilterReport', 'issueSeverity');
const ReportSeveritySearch = searchFactory('issueSeverityFilterReport');
const ReportStatusFilter = tieredFilterEntity('report', 'statusFilterReport', 'status');
const ReportStatusSearch = searchFactory('statusFilterReport');
const ReportTagFilter = tieredFilterEntity('report', 'reportTagFilterReport', 'reportTag');
const ReportTagSearch = searchFactory('reportTagFilterReport');
const ReportTypeFilter = tieredFilterEntity('report', 'reportTypeFilterReport', 'reportType');
const ReportTypeSearch = searchFactory('reportTypeFilterReport');
const ReportAssignmentFilter = tieredFilterEntity('report', 'reportAssignmentFilterReport', 'reportAssignment');
const ReportAssignmentSearch = searchFactory('reportAssignmentFilterReport');
const ReportFilters = ({
  formTypeActions: {
    serverIndex
  },
  formType: {
    list: formTypeList = []
  },
  displaySettingsList,
  reportActions,
  reportIndexQuery,
  settings: {
    settings: {
      cabinets: {
        report: {
          filters: reportFormFilters = []
        } = {}
      } = {}
    } = {}
  },
  username: _username = '',
  onMetaDeletedChange: _onMetaDeletedChange = () => {}
}) => {
  var _reportIndexQuery$fil, _reportIndexQuery$fil2, _reportIndexQuery$fil3;
  // Admin user check - easy to modify later to enable for all users
  // To enable for all users, simply change this to: const isAdminUser = true;
  const isAdminUser = _username === 'truqc';
  useEffect(() => {
    if (reportFormFilters.length > 0) {
      serverIndex({
        reportFormFilters
      });
    }
  }, [serverIndex, reportFormFilters]);

  // this variables stores the input created in the
  // ControlFilterSwitch and allows us to access it directly.
  let controlFilterSwitch;
  // needed for the issue items control.
  const handleBack = () => {
    // switch control back to top level.
    controlFilterSwitch.controlSwitch.switchControl();
  };
  const reportJobAndPhaseCodeFilter = /*#__PURE__*/React.createElement(JobAndPhaseCodeFilter, {
    onBack: handleBack
  });
  const reportWeekEndingFilter = /*#__PURE__*/React.createElement(WeekEndingFilter, {
    onBack: handleBack,
    indexQuery: reportIndexQuery,
    serverFilter: reportActions.serverFilter
  });

  // filterOnCreator: is there to trigger the filter handling on the server
  const reportCreatorFilter = /*#__PURE__*/React.createElement(ReportCreatorFilter, {
    label: "Creator",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportCreatorSearch, null));
  const reportReportTypeFilter = /*#__PURE__*/React.createElement(ReportTypeFilter, {
    label: "Report Type",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportTypeSearch, null));
  const reportAssignmentFilter = /*#__PURE__*/React.createElement(ReportAssignmentFilter, {
    label: "Assigned To",
    getOptionName: option => _objectSpread(_objectSpread({}, option), {}, {
      name: `${option.firstName} ${option.lastName}`
    }),
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportAssignmentSearch, null));
  const reportOrganizationFilter = /*#__PURE__*/React.createElement(ReportOrganizationFilter, {
    label: "Organizations",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportOrganizationSearch, null));
  const reportAssetFilter = /*#__PURE__*/React.createElement(ReportAssetFilter, {
    label: "Asset",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportAssetSearch, null));
  const reportReportTagFilter = /*#__PURE__*/React.createElement(ReportTagFilter, {
    label: "Tags",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportTagSearch, null));
  const reportStatusFilter = /*#__PURE__*/React.createElement(ReportStatusFilter, {
    label: "Status",
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(ReportStatusSearch, null));
  const reportPieceFilter = /*#__PURE__*/React.createElement(PieceFilter, {
    onBack: handleBack
  }, /*#__PURE__*/React.createElement(PieceSearch, null));
  const formFilters = [];
  // example reportFormFilter:
  // {
  //   "title": "Hull",
  //   "formTypeIdentifier": "hull"
  // }
  reportFormFilters.forEach(filter => {
    const formType = formTypeList.find(ft => ft.identifier === filter.formTypeIdentifier);
    if (formType) {
      const formFilter = /*#__PURE__*/React.createElement(ReportFormFilter, {
        label: filter.title,
        onBack: handleBack,
        formType: formType
      });
      formFilters.push({
        formFilter,
        identifier: filter.formTypeIdentifier,
        title: filter.title
      });
    }
  });

  // Create Show Deleted filter control (for admin users)
  const showDeletedFilterControl = isAdminUser ? {
    label: 'Show Deleted',
    entity: 'ShowDeleted',
    filterName: 'metaDeleted',
    control: /*#__PURE__*/React.createElement(ShowDeletedFilter, {
      value: (_reportIndexQuery$fil = reportIndexQuery === null || reportIndexQuery === void 0 || (_reportIndexQuery$fil2 = reportIndexQuery.filters) === null || _reportIndexQuery$fil2 === void 0 ? void 0 : _reportIndexQuery$fil2.metaDeleted) !== null && _reportIndexQuery$fil !== void 0 ? _reportIndexQuery$fil : 0,
      onChange: _onMetaDeletedChange,
      onBack: handleBack
    }),
    titleValues: [(reportIndexQuery === null || reportIndexQuery === void 0 || (_reportIndexQuery$fil3 = reportIndexQuery.filters) === null || _reportIndexQuery$fil3 === void 0 ? void 0 : _reportIndexQuery$fil3.metaDeleted) === 1 ? 'Yes' : 'No'],
    filters: reportIndexQuery.filters
  } : null;

  // Start with Show Deleted filter if admin user
  const filterControls = showDeletedFilterControl ? [showDeletedFilterControl] : [];

  // Add standard filters
  filterControls.push({
    label: 'Organizations',
    entity: 'Organization',
    filterName: 'organization',
    control: reportOrganizationFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Job',
    entity: 'Job',
    filterName: ['jobPhaseCode', 'job'],
    control: reportJobAndPhaseCodeFilter,
    keepParent: true,
    filters: reportIndexQuery.filters
  }, {
    control: reportWeekEndingFilter,
    label: 'Week Ending',
    entity: 'weekEnding',
    filterName: 'weekEnding',
    filters: reportIndexQuery.filters
  }, {
    label: 'Assigned To',
    entity: 'ReportAssignment',
    filterName: 'reportAssignment',
    control: reportAssignmentFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Report Types',
    entity: 'ReportType',
    filterName: 'reportType',
    control: reportReportTypeFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Creator',
    entity: 'Creator',
    filterName: 'user',
    control: reportCreatorFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Status',
    entity: 'Status',
    filterName: 'status',
    control: reportStatusFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Tags',
    entity: 'ReportTag',
    filterName: 'reportTag',
    control: reportReportTagFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Piece',
    entity: 'JobPiece',
    filterName: ['jobPiece', 'pieceOther'],
    control: reportPieceFilter,
    filters: reportIndexQuery.filters
  }, {
    label: 'Assets',
    entity: 'Asset',
    filterName: 'asset',
    control: reportAssetFilter,
    filters: reportIndexQuery.filters
  });
  formFilters.forEach(ff => {
    filterControls.push({
      label: ff.title,
      entity: 'Form',
      filterName: 'form',
      control: ff.formFilter,
      filters: reportIndexQuery.filters
    });
  });
  /*
     * some report filters should only be visible
     * with specific user permissions
     */
  if (getIsPermittedWithAnyOfThesePermissions(['issue_show'])) {
    const reportSeveritySelect = /*#__PURE__*/React.createElement(ReportSeverityFilter, {
      label: "Issue Severity",
      onBack: handleBack
    }, /*#__PURE__*/React.createElement(ReportSeveritySearch, null));
    filterControls.push({
      label: 'Issue Severity',
      entity: 'IssueSeverity',
      filterName: 'issueSeverity',
      control: reportSeveritySelect,
      filters: reportIndexQuery.filters
    });
  }
  if (displaySettings.shouldDisplay(['current_state'], displaySettingsList)) {
    const reportCurrentStateFilter = /*#__PURE__*/React.createElement(ReportCurrentStateFilter, {
      label: "Current State",
      onBack: handleBack
    }, /*#__PURE__*/React.createElement(ReportCurrentStateSearch, null));
    filterControls.push({
      label: 'Current State',
      entity: 'CurrentState',
      filterName: 'currentState',
      control: reportCurrentStateFilter,
      filters: reportIndexQuery.filters
    });
  }
  return /*#__PURE__*/React.createElement(ControlFilterSwitch, {
    filterControls: filterControls,
    ref: input => {
      controlFilterSwitch = input;
    }
  });
};
ReportFilters.propTypes = {
  displaySettingsList: PropTypes.arrayOf(PropTypes.shape({
    identifier: PropTypes.string
  })).isRequired,
  reportActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  formTypeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  formActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  reportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      metaDeleted: PropTypes.number
    })
  }).isRequired,
  formTypeIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  formIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({})
  }).isRequired,
  settings: PropTypes.shape({
    settings: PropTypes.shape({})
  }).isRequired,
  formType: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  form: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  username: PropTypes.string,
  onMetaDeletedChange: PropTypes.func
};
export { ReportFilters as TestReportFilters };
export default entityComposition(ReportFilters, ['settings', 'formType', 'form'], {
  reportIndexQuery: state => state.report.indexQuery,
  formTypeIndexQuery: state => state.formType.indexQuery,
  formIndexQuery: state => state.formType.indexQuery,
  displaySettingsList: state => state.displaySettings.list
}, ['report']);